module.exports = "/_next/static/images/4b6f54301ca46c166a313af032cd4a55-shield-circle.svg";